import {
  enUS,
  enGB,
  ar,
  bg,
  bn,
  cs,
  da,
  de,
  es,
  fi,
  fr,
  frCA,
  he,
  hi,
  hr,
  hu,
  hy,
  id,
  it,
  ja,
  ka,
  kk,
  km,
  kn,
  ko,
  lt,
  ms,
  nl,
  pl,
  pt,
  ptBR,
  ro,
  ru,
  sl,
  sk,
  sr,
  sv,
  th,
  tr,
  uk,
  vi,
  zhCN,
  zhHK,
  zhTW,
} from 'date-fns/locale';

/**
 * Mapping from i18next supported locales into date-fns locale objects
 */
const dateLocales = {
  en: enUS,
  'en-GB': enGB,
  ar,
  bg,
  bn,
  cs,
  da,
  de,
  es,
  fi,
  fr,
  'fr-CA': frCA,
  he,
  hi,
  hr,
  hu,
  hy,
  id,
  'id-ID': id,
  it,
  ja,
  ka,
  kk,
  'km-KH': km,
  kn,
  ko,
  lt,
  'ms-MY': ms,
  nl,
  pl,
  pt,
  'pt-BR': ptBR,
  ro,
  ru,
  sl,
  sk,
  sr,
  sv,
  th,
  tr,
  uk,
  vi,
  'vi-VN': vi,
  'zh-CN': zhCN,
  'zh-HK': zhHK,
  'zh-TW': zhTW,
};

export default dateLocales;
